import logo from './logo.svg';
import './App.css';
import VideoAnalysis from './VideoAnalysis';

function App() {
  return (
    <div>
      <VideoAnalysis />
    </div>
  );
}

export default App;
